<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Valyuta konvertoru</h1>
        <p>
          Azərbaycan Respublikası Mərkəzi Bankının
          <strong>{{ date }}</strong> tarixə olan xarici valyutalarının
          Azərbaycan manatına qarşı rəsmi məzənnələri.
        </p>
      </div>

      <div class="col-12" v-if="loading">
        <div class="spinner">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <transition-group tag="div" appear name="fade" mode="out-in" v-else>
        <!-- Переключатель -->
        <div class="col-md-4 select-category d-flex" key="radio">
          <input
            type="radio"
            id="main"
            value="main"
            v-model="category"
            :class="{ active: activated }"
            @click="activated = !activated"
          />
          <label for="main">əsas</label>
          <input
            type="radio"
            id="all"
            value="all"
            v-model="category"
            :class="{ active: !activated }"
            @click="activated = !activated"
          />
          <label for="all">hamısı</label>
        </div>

        <!-- AZN -->
        <div
          class="block col-12 d-flex align-items-center justify-content-start"
          key="azn"
        >
          <label>AZN</label>
          <input type="number" v-model="AZN" @input="calc(null, 'AZN')" />
          <p>Azərbaycan manatı</p>
        </div>

        <!-- VALUTE -->
        <div
          class="block col-12 d-flex align-items-center justify-content-start"
          v-for="(item, index) in filtered"
          :key="index + 0"
        >
          <label>{{ item["@attributes"].Code }}</label>
          <input
            type="number"
            v-model="values[index]"
            @input="calc(index, item['@attributes'].Code)"
          />
          <p>
            {{ item.Name }} - <strong>{{ fixedVal(item.Value, 4) }}</strong> AZN
          </p>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      AZN: "",
      date: "",
      values: [],
      currencies: [],
      category: "main",
      activated: true,
      loading: false,
    };
  },

  computed: {
    filtered: function () {
      let self = this;
      self.values = [];
      self.AZN = "";
      if (self.category == "all") {
        return self.currencies;
      } else {
        return self.currencies.filter(function (item) {
          return (
            item["@attributes"].Code === "USD" ||
            item["@attributes"].Code === "RUB" ||
            item["@attributes"].Code === "EUR" ||
            item["@attributes"].Code === "TRY"
          );
        });
      }
    },
  },

  methods: {
    calc: function (index, val) {
      if (val == "AZN") {
        for (let i = 0; i < this.filtered.length; i++) {
          this.values[i] = this.fixedVal(this.AZN / this.filtered[i].Value, 2);
        }
      } else {
        this.AZN = this.fixedVal(
          this.values[index] * this.filtered[index].Value,
          2
        );
        for (let i = 0; i < this.filtered.length; i++) {
          if (i != index) {
            this.values[i] = this.fixedVal(
              this.AZN / this.filtered[i].Value,
              2
            );
          }
        }
      }
    },

    fixedVal(num, x) {
      return parseFloat(num)
        .toFixed(x + 1)
        .slice(0, -1);
    },
  },

  mounted() {
    this.loading = true;
    axios
      .get("inc/cbar.php")
      .then((response) => {
        this.currencies = response.data.ValType[1].Valute;
        this.date = response.data["@attributes"].Date;

        // format rubl start
        let rubIndex = this.currencies.findIndex(
          (c) => c["@attributes"].Code == "RUB"
        );
        this.currencies[rubIndex].Value = this.currencies[rubIndex].Value / 100;
        this.currencies[rubIndex].Name = "1 Rusiya rublu";
        // format rubl end

        this.loading = false;
      })
      .catch((error) => {
        this.loading = true;
      });
  },
};
</script>

<style scoped>
.select-category {
  margin-bottom: 2rem;
  padding-left: 100px;
}
.select-category label {
  background: #ccc;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: all 0.5s ease;
  font-weight: bold;
}

.select-category input[type="radio"] {
  display: none;
}
.select-category input.active + label {
  background: #003366;
  color: #fff;
  background-position: left bottom;
}
.block label {
  margin: 1rem;
  font-weight: bold;
  display: block;
  width: 50px;
}
.block input {
  width: 180px;
  margin-right: 1rem;
}

input[type="radio"] {
  height: auto;
  width: 50px;
}

@media only screen and (max-width: 768px) {
  .block {
    flex-wrap: wrap;
  }
  .block input {
    width: calc(100% - 85px);
    margin-right: 0;
  }
  .block p {
    width: 100%;
    margin: 0;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/calc/Currency.vue